import { useMutation } from '@tanstack/react-query';
import { authoriseSignature, fetchAuthPayload } from './auth-api';
import { AuthConnectRequest, AuthConnectResponse, AuthPayloadRequest, AuthPayloadResponse } from '@/api/spec.ts';

export const useGetAuthPayload = () => {
  return useMutation<AuthPayloadResponse, Error, AuthPayloadRequest>({
    mutationFn: (request: AuthPayloadRequest) => fetchAuthPayload(request),
    retry: 0,
    meta: { sentryHandled: true },
  });
};

export const useAuthSignatureMutation = () => {
  return useMutation<AuthConnectResponse, Error, AuthConnectRequest>({
    mutationFn: (request: AuthConnectRequest) => authoriseSignature(request),
    retry: 0,
    meta: { sentryHandled: true },
  });
};
